module.exports = __webpack_public_path__ + "img/cartNo_bg.6317faa5.png";